module.exports = __webpack_public_path__ + "static/img/图片3.5395c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/图片3.png
// module id = Q09/
// module chunks = 1